<!--
 * @Author: your name
 * @Date: 2020-07-22 16:47:26
 * @LastEditTime: 2020-12-04 14:34:45
 * @LastEditors: Please set LastEditors
 * @Description: 判断题 C
 * @FilePath: \vue-gaokao-ebook\src\components\question-type\judge_question.vue
--> 
<template>

  <!-- 判断题  -->
  <div :class="isComposite ? 'question-c' : 'question'" :id="'anchor'+q.id">
    <assessment  :is-show-correct-btn="isShowCorrectBtn" :composite-name="compositeName"  :is-composite="isComposite" :question="question" :show-analysis="showAnalysis"></assessment>
  </div>
</template>

<script>
import questionHandle from "@/assets/js/question-handle";
import assessment from "@/components/paper/question/assessment/result_assessment.vue"
export default {
  name: "base_question_result",
  data() {
    return {
      q: {},
      choose_option: "",
      major_question_code : ["S","E"]
    };
  },
  components :{
    assessment,
  },
  props: {
    isComposite: {
      type: Boolean,
      default: false,
    },
    compositeName :{
      type : String,
      default : '复合题'
    },
    question: {
      type: Object,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    isShowAnswerArea:{
      type: Boolean,
      default : true
    },
    isShowCorrectBtn : {
      type : Boolean,
      default : true
    },
    isShowSelfAnswer : {
      type : Boolean,
      default : false
    },
    fontSize: {
      type: Number,
      default: 24
    },
    showAnalysis: {
      type: Boolean,
      default: true
    },
    qTab: {
      type: Number,
      default: 0
    }
  },
  methods: {
    formatQuestion(ques) {
      this.q = questionHandle.formatQuestion(ques);
		},
  },
  mounted() {
    this.formatQuestion(this.question);
    let _this = this;
    this.$root.eventHub.$on("question-tab-changed", (val,id) => {
      if(!_this.isComposite){
        if(id && id == this.question.id){
          let top = document.getElementById("anchor"+id).offsetTop;
          scrollTo(0,top);
        }
        
      }
    });
  }
}
</script>

<style lang="stylus" scoped>
.border_bottom {
  // border-bottom: 30px #f5f5f5 solid;
}
.question {
  margin-top : 30px;
  width: 1531px;
  // position: relative;
  background-color : #f5f5f5;
  margin-left : 30px;
  padding-bottom: 30px;
}
.question-c {
  width: 1531px;
  position: relative;
  // background-color : #f5f5f5;
  margin-left : -92px;
}
</style>